import { provideTransloco, TranslocoModule } from '@jsverse/transloco';
import { isDevMode, NgModule } from '@angular/core';
import { TranslocoHttpLoader } from './transloco.http-loader';
import { provideHttpClient } from '@angular/common/http';

@NgModule({
    exports  : [ TranslocoModule ],
    providers: [
        provideHttpClient(),
        provideTransloco({
          config: {
            availableLangs: ['en', 'fr', 'sn', 'ar'],
            defaultLang: 'fr',
            fallbackLang: 'fr',
            reRenderOnLangChange: true,
            prodMode: !isDevMode(),
            // Garde le nom exact des scopes comme alias (sinon Transloco camelCase
            // par defaut). Sans ca, les scopes hyphenes (public-document,
            // sinistre-parameter) sont aliases en publicDocument/sinistreParameter
            // et leurs cles hyphenees ne resolvent pas -> cles brutes affichees.
            scopes: { keepCasing: true },
            missingHandler: {
              useFallbackTranslation: true,
              logMissingKey: true
            }
          },
          loader: TranslocoHttpLoader,
        }),
    ],
})
export class TranslocoCoreModule { }
